import React from 'react';
import {Navigate, useSearchParams} from 'react-router-dom';
import {useAuth} from 'react-oidc-context';
import {CircularProgress} from '@mui/material';
import {useAppSelector} from '../../../../../Config/Hooks';
import {useAuthToken} from '../../../../../Config/Hooks/useAuthToken';
import {
    isAuthorizedForManagementOverviewReport,
    parseManagementOverviewSearchParams,
} from '../utils/managementOverviewRoute';
import ManagementOverviewReportPage from '../ManagementOverviewReportPage';

const ManagementOverviewProtectedRoute: React.FC = () => {
    const [searchParams] = useSearchParams();
    const auth = useAuth();
    const {isAuthenticated: sessionReady} = useAuthToken();
    const account = useAppSelector((state) => state.authentication.account);
    const validation = parseManagementOverviewSearchParams(searchParams);

    const isSessionInitializing =
        auth.isLoading
        || (auth.isAuthenticated && !sessionReady);

    if (isSessionInitializing) {
        return (
            <div className="management-overview-status" role="status" aria-live="polite" aria-busy="true">
                <CircularProgress size={32} aria-label="Carregando sessão" />
                <span>Carregando...</span>
            </div>
        );
    }

    if (!sessionReady) {
        return <Navigate to="/" replace />;
    }

    if (!isAuthorizedForManagementOverviewReport(account?.authoritySet)) {
        return (
            <div className="management-overview-status" role="alert">
                Você não está autorizado à acessar essa página
            </div>
        );
    }

    if (!validation.valid) {
        return (
            <ManagementOverviewReportPage invalidParams />
        );
    }

    return (
        <ManagementOverviewReportPage
            requestParams={validation.params}
        />
    );
};

export default ManagementOverviewProtectedRoute;
